import React from 'react';
import {Heading} from '../../components/guide/Heading';
import HeaderPath from "../../components/common/HeaderPath";
import SectionBg from "../../assets/images/bg/allinone_section_bg.png";
import SectionMobileBg from "../../assets/images/bg/allinone_mobile_section_bg.svg";
import CtaBanner from "../../components/guide/CtaBanner";

const PrincipleAllInOnePage: React.FC = () => (
    <section className="w-full bg-white">
        <div className="mx-auto w-full max-w-[1072px] px-0 sm:px-6 lg:px-0">
            <HeaderPath path={'> 분양의신 3원칙 > 올인원(All-in-One) 대행 시스템'}/>
            <h1 className="hidden text-[36px] font-[700] lg:mb-[104px] lg:block lg:text-[47px]">
                <span className="mr-3 text-[#0000ED]">02</span> 올인원(All-in-One) 대행 시스템
            </h1>
            <Heading as="p" size="subtitle" className="text-black font-[600] leading-relaxed">
                “광고는 복잡해야 하지만, 고객은 단순해야 합니다.”
            </Heading>

            <Heading as="p" size="subtitle" className="mt-4 text-black font-[400] leading-relaxed">
                분양 광고는 생각보다 훨씬 복잡합니다.<br/>
                시장 분석, 타겟팅, 경쟁조사, 광고 기획, 디자인, 세팅, 집행, 리포트 작성, 최적화 …<br/>
                이 모든 과정을 광고주 혼자 감당하기엔 시간도, 전문성도, 여유도 부족합니다.<br/>
                <br/>
                많은 분들이 이렇게 말합니다.<br/>
                “자료 준비가 너무 번거롭다.”<br/>
                “광고를 어떻게 시작해야 할지 모르겠다.”<br/>
                “결과는 중요한데, 내가 일일이 챙기긴 어렵다.”<br/>
                <br/>
                <span className={'font-[600]'}>그래서 분양의신은 광고에 필요한 전 과정을 하나로 묶은 ‘올인원(All-in-One) 대행 시스템’을 구축했습니다.</span>
            </Heading>
            <div className="mt-12 flex flex-col gap-12 sm:mt-16 lg:mt-[95px] lg:gap-[95px]">
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        📦 분양의신 올인원 시스템 구조
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 pt-6 md:pb-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        고객님의 단 10분의 자료 전달만으로도 광고는 시작됩니다. 이후의 모든 단계는 저희가 책임지고 처리합니다.<br/>
                    </p>
                    <div
                        className="bg-[#F5F5F5] md:bg-white px-5 md:px-0 pt-[10px] md:pt-0 pb-[20px] md:pb-0 md:mt-4"
                        style={{
                            fontFamily:
                                "Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, Noto Sans, Helvetica, Arial, Apple Color Emoji, Segoe UI Emoji",
                        }}
                    >
                        <div className="overflow-x-auto rounded-lg">
                            <table
                                className="w-full border-collapse text-center text-sm font-normal leading-tight tracking-[0] sm:text-[16px]">
                                <thead>
                                <tr>
                                    <th className="border border-[#E0E4E8] bg-[#343A40] px-1 py-1 md:px-4 md:py-3 text-white">단계</th>
                                    <th className="whitespace-nowrap border border-[#E0E4E8] bg-[#343A40] px-1 py-1 md:px-4 md:py-3 text-white">고객의
                                        역할
                                    </th>
                                    <th className="border border-[#E0E4E8] bg-[#343A40] px-1 py-1 md:px-4 md:py-3 text-white">분양의신
                                        역할
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr className="align-middle">
                                    <td className="text-left border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3 bg-[#F1F3F5]"><span
                                        className={'font-[600]'}>STEP 1.</span> 정보 수집
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">필수 자료만 전달
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">시장조사 및 타겟
                                        분석
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left  border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3 bg-[#F1F3F5]"><span
                                        className={'font-[600]'}>STEP 2.</span> 전략 설계
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">선택적으로 검토
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">광고 기획안 및
                                        소구점 개발
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left  border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3 bg-[#F1F3F5]"><span
                                        className={'font-[600]'}>STEP 3.</span> 실행 및 세팅
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">없음</td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">배너/홈페이지
                                        디자인, 셋팅,
                                        집행 전체
                                        진행
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left  border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3 bg-[#F1F3F5]"><span
                                        className={'font-[600]'}>STEP 4.</span> 보고 및 최적화
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">확인</td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">일일/주간/결과
                                        리포트 제공
                                        및 개선안
                                        도출
                                    </td>
                                </tr>
                                <tr className="align-middle">
                                    <td className="text-left  border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3 bg-[#F1F3F5]"><span
                                        className={'font-[600]'}>STEP 5.</span> 내부 보고 지원
                                    </td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">없음</td>
                                    <td className="bg-white border border-[#E0E4E8] px-1 py-1 md:px-4 md:py-3">상부 보고용
                                        결과자료, 제안서,
                                        광고비
                                        지원요청서 작성
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        💡 왜 이 시스템이 필요한가요?
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        ✅ <span className={'font-[700]'}>시간을 돌려드립니다</span><br/>
                        광고는 분양의신이 책임지고, 고객은 고객 관리에 집중하시면 됩니다. 시간은 줄이고, 성과는 높입니다.<br/>
                        <br/>
                        ✅ <span className={'font-[700]'}>전문가들이 직접 움직입니다</span><br/>
                        기획, 디자인, 마케팅, 미디어 플래너 등 각 파트의 전문가가 투입되어 광고의 품질과 효율을 높입니다.<br/>
                        <br/>
                        ✅ <span className={'font-[700]'}>광고 외 업무까지 해결합니다</span><br/>
                        광고 진행뿐 아니라, 상부 보고용 제안서, 성과 요약본, 제출용 지원요청서 등 내부 커뮤니케이션 자료까지 모두 대신 제작합니다.<br/>
                        자료를 다시 정리하거나, 보고서를 따로 만들 필요 없습니다.
                    </p>
                </div>
                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        🛠 우리는 외주를 쓰지 않습니다
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        분양의신은 타사와 달리 전 과정 인하우스로 운영됩니다.<br/>
                        <br/>
                        📌 디자인팀, 카피라이터, 마케터, 미디어 운영팀 전원 내부 인력<br/>
                        📌 업계 최초 몰입아트 영상을 제작하는 미디어 아트디자인팀 보유<br/>
                        📌 업계 최다 디자이너 보유<br/>
                        <br/>
                        외주에 의존하지 않기 때문에 <span className={'font-[700]'}>커뮤니케이션이 빠르고 책임 소재가 분명하며, 빠른 피드백 · 유연한 수정 · 철저한 보안이 가능하고,</span><br/>
                        무엇보다 <span className={'font-[700]'}>결과에 대한 품질 관리가 확실</span>합니다.
                    </p>
                </div>

                <div>
                    <h2 className="mb-4 text-[20px] font-[600] leading-[30px] sm:mb-[15px] sm:text-[25px]">
                        ⚖️ 고객의 시간과 업무를 줄이는 파트너
                    </h2>
                    <p className="bg-[#F5F5F5] px-5 py-6 text-sm font-[400] leading-relaxed text-black sm:px-[38px] sm:py-[22px] sm:text-[16px]">
                        분양의신은 단순히 ‘광고를 집행해주는 회사’가 아닙니다.<br/>
                        광고를 시작하는 순간부터, 결과 보고가 끝나는 그 순간까지, 고객이 겪는 <span
                        className={'font-[700]'}>모든 복잡함을 대신 해결하는 진짜 파트너</span>입니다.<br/>
                        <br/>
                        📌 광고를 잘 모르는 고객도<br/>
                        📌 내부 결재가 까다로운 회사도<br/>
                        📌 시간이 부족한 담당자도<br/>
                        <br/>
                        <span className={'font-[700]'}>분양의신을 만나면 광고가 ‘일’이 되지 않습니다.</span>
                    </p>
                </div>
                <div
                    className="block md:hidden rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionMobileBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                        backgroundPosition: 'right'
                    }}>
                    우리는 광고를 단순히 ‘대행’하지 않습니다.<br/>
                    고객님의 업무 자체를 줄여드립니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    기획, 실행, 보고는 물론 상부 보고용 자료까지 미리 준비하는 이유는 단 하나 —<br/>
                광고를 넘어서, 고객의 성과와 시간을 책임지기 위함입니다.
                </span>
                </div>
                <div
                    className="hidden md:block rounded-[6px] py-8 px-6 text-base font-[400] leading-[30px] text-white sm:text-[16px] sm:leading-[30px] sm:py-[36px] sm:px-[58px]"
                    style={{
                        backgroundImage: `url(${SectionBg})`,
                        backgroundRepeat: 'no-repeat',
                        backgroundSize: 'cover',
                    }}>
                    우리는 광고를 단순히 ‘대행’하지 않습니다.<br/>
                    고객님의 업무 자체를 줄여드립니다.<br/>
                    <span className={'font-[700] block mt-4'}>
                    기획, 실행, 보고는 물론 상부 보고용 자료까지 미리 준비하는 이유는 단 하나 —<br/>
                광고를 넘어서, 고객의 성과와 시간을 책임지기 위함입니다.
                </span>
                </div>
                <CtaBanner
                    message="기획부터 보고까지, 광고가 '일'이 되지 않도록."
                    buttonText="광고문의 바로가기 →"
                    href="https://분양의신.net/contact"
                />
            </div>
        </div>
    </section>
);

export default PrincipleAllInOnePage;
